import { render } from "./NerpathamProfile.vue?vue&type=template&id=755f9739&scoped=true"
import script from "./NerpathamProfile.vue?vue&type=script&lang=js"
export * from "./NerpathamProfile.vue?vue&type=script&lang=js"

import "./NerpathamProfile.vue?vue&type=style&index=0&id=755f9739&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755f9739"]])

export default __exports__